export default function FilterType({ id, filterFunction } = {}) {
  return {
    id,
    filterFunction,
  };
}
